import React from "react";
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button
} from "react-bootstrap";

export default class BucketSearch extends React.Component {
  debounce = fn => {
    let timeout;
    return function() {
      const functionCall = () => fn.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, 500);
    };
  };
  componentDidMount() {
    this.handleSearchExpressionChange = this.debounce(
      this.handleSearchExpressionChange
    );
  }

  handleSearchExpressionChange = () => {
    const { setCurrentPage } = this.props;
    setCurrentPage(1);
    const { fetchSearchResults } = this.props;
    fetchSearchResults();
  };

  render() {
    const { getSearchExpression, setSearchExpression, type } = this.props;
    return (
      <FormGroup className="bucket-search-bar">
        <InputGroup>
          <FormControl
            type="text"
            value={getSearchExpression}
            onChange={(e) => {
              setSearchExpression(type, e.target.value)
              this.handleSearchExpressionChange();
            }}
            placeholder={"Search for " + type}
          />
          <InputGroup.Button>
            <Button
              onClick={() => {
                setSearchExpression(type, "");
                this.handleSearchExpressionChange();
              }}
            >
              Clear
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </FormGroup>
    );
  }
}
